import { Link } from "react-router-dom";

const Sidebar = () => {
    return (
        <div style={{ width: "200px", height: "100vh", background: "#333", color: "white", padding: "20px", position: "fixed" }}>
            <h2>Admin Panel</h2>
            <nav>
                <ul style={{ listStyle: "none", padding: 0 }}>
                    <li><Link to="/">Dashboard</Link></li>
                    <li><Link to="/employees">Employees</Link></li>
                    <li><Link to="/reports">Reports</Link></li>
                    <li><Link to="/settings">Settings</Link></li>
                </ul>
            </nav>
        </div>
    );
};

export default Sidebar;
